import { ExtraDataMatch, NewShirt } from "./types";

export const shirtToShirtData = (shirt: any) => {
  const shirtData: NewShirt = {
    brand_id: shirt.model.brand?.id,
    certificate: shirt.certificate,
    competition_id: shirt.model.competition.id,
    condition_id: shirt.condition.id,
    description: shirt.description,
    number: shirt.model.number,
    player_id: shirt.model?.player?.id,
    private: shirt.is_private,
    purchase_date: shirt.purchase_date,
    purchase_price: Number(shirt.purchase_price),
    season_id: shirt.model.season.id,
    shirt_type_id: shirt.model.type.id,
    signature: shirt.signature !== undefined && shirt.signature !== null,
    signature_data: shirt.signature?.description,
    team_id: shirt.model.team?.id,
    text: shirt.model.text,
    title: shirt.title,
    variant_id: shirt.model.variant.id,
    irresistible_offers: shirt.irresistible_offers,
    size: shirt.size,
    // Handle custom fields - check if we have custom values from the backend
    team_custom: shirt.model.team_custom || shirt.team_custom,
    brand_custom: shirt.model.brand_custom || shirt.brand_custom,
    player_custom: shirt.model.player_custom || shirt.player_custom,
    custom_number: shirt.model.custom_number || shirt.custom_number,
  };

  return shirtData;
};

export function isExtraDataMatch(anyObject: any): anyObject is ExtraDataMatch {
  return typeof anyObject?.match !== "undefined";
}

export function isExtraDataValue(anyObject: any): anyObject is ExtraDataMatch {
  return typeof anyObject?.value !== "undefined";
}
